import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import '../styles/WaitingRoom.css';
import '../styles/BaseForm.css';
import fr from '../locales/fr';
import en from '../locales/en';
import image1 from '../img_spooky/halloween_prop1.png';
import image2 from '../img_spooky/halloween_prop2.png';
import image3 from '../img_spooky/halloween_prop3.png';
import image4 from '../img_spooky/halloween_prop4.png';
import image5 from '../img_spooky/halloween_prop5.png';
import image6 from '../img_spooky/halloween_prop6.png';
import image7 from '../img_spooky/halloween_prop7.png';
import image8 from '../img_spooky/halloween_prop8.png';
import image9 from '../img_spooky/halloween_prop9.png';
import image10 from '../img_spooky/halloween_prop10.png';
import image11 from '../img_spooky/halloween_prop11.png';
import image12 from '../img_spooky/halloween_prop12.png';
import image13 from '../img_spooky/halloween_prop13.png';
import image14 from '../img_spooky/halloween_prop14.png';
import image15 from '../img_spooky/halloween_prop15.png';

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
};

const setCookie = (name, value, minutes = 120) => {
  const expires = new Date(Date.now() + minutes * 60000).toUTCString();
  document.cookie = `${name}=${value};expires=${expires};path=/`;
};

const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
};

function OnTv({ ws }) {
  const navigate = useNavigate();
  const location = useLocation();
  const browserLang = navigator.language || navigator.userLanguage;
  const language = browserLang.startsWith('fr') ? 'fr' : 'en';
  const translations = language === 'fr' ? fr : en;

  const allowed =
    location.state?.fromAuthorized ||
    sessionStorage.getItem('canAccessOnTV');

  const savedRole = getCookie('playerRole');

  const [role, setRole] = useState(savedRole || null);
  const [countdown, setCountdown] = useState(null);

  const intervalRef = useRef(null);
  const roleRef = useRef(savedRole || null);
  const rdySentRef = useRef(false);
  const countdownActiveRef = useRef(false);

  document.cookie = 'playerResponses=; expires=Thu, 05 Oct 2000 00:00:00 UTC; path=/;';

  useEffect(() => {


    const generateImages = () => {
      const numberOfImages = 5;
      const container = document.querySelector('.container');
      if (!container) return;

      const images = [
        image1, image2, image3, image4, image5, image6, image7, image8, image9,
        image10, image11, image12, image13, image14, image15
      ];

      for (let i = 0; i < numberOfImages; i++) {
        const image = document.createElement('img');
        const randomImageIndex = Math.floor(Math.random() * images.length);
        const randomSize = Math.random() * 50 + 30;
        const randomX = Math.random() * (window.innerWidth - randomSize);
        const randomAnimationDuration = Math.random() * 5 + 2;

        image.setAttribute('src', images[randomImageIndex]);
        image.classList.add('rain-image');
        image.style.width = `${randomSize}px`;
        image.style.position = 'absolute';
        image.style.left = `${randomX}px`;
        image.style.top = `-${randomSize}px`;
        image.style.animationDuration = `${randomAnimationDuration}s`;
        image.style.transition = `top ${randomAnimationDuration}s linear`;

        container.appendChild(image);

        setTimeout(() => {
          image.style.top = `${window.innerHeight}px`;
        }, 0);
      }
      container.addEventListener('transitionend', handleTransitionEnd);
    };

    const handleTransitionEnd = (event) => {
      const container = document.querySelector('.container');
      const image = event.target;

      if (container.contains(image)) {
        container.removeChild(image);
      }
    };

    const handleWebSocketMessage = (event) => {
      const message = event.data;
      const ROOM = localStorage.getItem('UNITY');

      if (!ROOM) return;

      // ------------------------------------------
      // Gestion du rôle STARTER (joueur maître)
      // ------------------------------------------
      if (message === ROOM + ':STARTER') {
        // Annuler un éventuel compte à rebours
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }

        setCountdown(null);
        roleRef.current = 'starter';
        setCookie('playerRole', 'starter');
        setRole('starter');
        return;
      }

      // ------------------------------------------
      // La partie peut continuer (GO)
      // ------------------------------------------
      if (message === ROOM + ':GO') {
        // On accepte GO uniquement si ce joueur était STARTER
        if (roleRef.current === 'starter') {
          setCookie('playerRole', 'go');
          roleRef.current = 'go';
          setRole('go');
          ws.send(ROOM + ':STARTER OK');
        }
        return;
      }

      // ------------------------------------------
      // Retour en attente
      // ------------------------------------------
      if (message === ROOM + ':WAIT') {
        // Annuler un éventuel compte à rebours
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }

        setCountdown(null);

        // Le joueur n'est plus dans l'état GO
        roleRef.current = 'waiting';
        setCookie('playerRole', 'waiting');
        setRole('waiting');

        ws.onmessage = null;
        ws.send(ROOM + ":CHECKSTATE");
        sessionStorage.setItem('canAccessWaitingState', 'true');
        navigate("/waitingState", { state: { fromAuthorized: true } });
        return;
      }

      // ------------------------------------------
      // Navigation vers d'autres pages
      // ------------------------------------------
      switch (message) {
        case ROOM + ":ANSWER":
          ws.onmessage = null;
          ws.send(ROOM + ":CHECKSTATE");
          sessionStorage.setItem('canAccessAnswer', 'true');
          navigate("/answer", { state: { fromAuthorized: true } });
          break;
        case ROOM + ":CLOSE":
          ws.onmessage = null;
          ws.send(ROOM + ":CHECKSTATE");
          sessionStorage.setItem('canAccessRestart', 'true');
          navigate("/restart", { state: { fromAuthorized: true } });
          break;
        case ROOM + ":VOTE":
          ws.onmessage = null;
          ws.send(ROOM + ":CHECKSTATE");
          sessionStorage.setItem('canAccessExportVote', 'true');
          navigate("/exportVote", { state: { fromAuthorized: true } });
          break;
        case ROOM + ':Salle Pleine':
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }
          deleteCookie('playerRole');
          navigate('/');
          break;
        default:
          console.log("Message non reconnu:", message);
      }
    };

    ws.onmessage = handleWebSocketMessage;

    generateImages();
    const interval = setInterval(generateImages, 2500);
    return () => {
      clearInterval(interval);
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      ws.onmessage = null;
    };
  }, [ws, navigate]);

  useEffect(() => {
    if (allowed) {
      sessionStorage.removeItem('canAccessOnTV');
    }
  }, [allowed]);

  // --------------------------------------------------
  // Démarrer la partie (pour STARTER)
  // --------------------------------------------------
  const handleStart = () => {
    // Évite de créer plusieurs intervals
    if (intervalRef.current) return;

    countdownActiveRef.current = true;
    setCountdown(5);

    let remaining = 5;

    intervalRef.current = setInterval(() => {
      remaining -= 1;

      if (remaining <= 0) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        countdownActiveRef.current = false;
        setCountdown(null);

        const ROOM = localStorage.getItem('UNITY');

        if (!ROOM || !ws) {
          return;
        }

        // Envoie RDY au serveur
        rdySentRef.current = true;
        ws.send(ROOM + ':RDY');

        deleteCookie('playerRole');

        sessionStorage.setItem('canAccessWaitingState', 'true');
        navigate('/waitingState', {
          state: { fromAuthorized: true }
        });
      } else {
        setCountdown(remaining);
      }
    }, 1000);
  };

  // --------------------------------------------------
  // Annuler le démarrage
  // --------------------------------------------------
  const handleCancel = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    countdownActiveRef.current = false;
    setCountdown(null);
  };

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  const isCounting = countdown !== null;

  // --------------------------------------------------
  // Affichage pour le joueur STARTER (maître du jeu)
  // --------------------------------------------------
  if (role === 'starter') {
    return (
      <div className="container">
        <h1 className="title">
          {translations.waitingState.title}
          <span className="dots"></span>
        </h1>
        <div className="loader"></div>
      </div>
    );
  }

  // --------------------------------------------------
  // Affichage pour le joueur GO (peut démarrer)
  // --------------------------------------------------
  if (role === 'go') {
    return (
      <div className="boxform">
        <h1 className="title">{translations.ready.title}</h1>
        <button
          className="submit-button"
          onClick={isCounting ? handleCancel : handleStart}
          style={
            isCounting
              ? {
                  background:
                    'linear-gradient(135deg, #ff4444 0%, #cc0000 100%)'
                }
              : undefined
          }
        >
          {isCounting
            ? `${translations.ready.cancel} (${countdown})`
            : translations.ready.button}
        </button>
      </div>
    );
  }

  // --------------------------------------------------
  // Affichage par défaut (joueur normal)
  // --------------------------------------------------
  return (
    <div className="container">
      <h1 className="title">{translations.onTV.title}</h1>
      <div className="loader"></div>
    </div>
  );
}

export default OnTv;
